import React from 'react';

import { STANDARD, ADVANCED, DEDICATED } from 'utils/licenseUtils';

import StandardIcon from '../Icons/StandardIcon';
import AdvancedIcon from '../Icons/AdvancedIcon';
import DedicatedIcon from '../Icons/DedicatedIcon';

import { StyledCheckIcon } from './License-Cards-styled';
import {
  StyledCardContainer,
  StyledCardTitle,
  StyledCardText,
  StyledPassiveCard
} from 'components/StyledComponents';

interface LicenseCardProps {
  licenseType: LicenseType | null;
}

const LicenseCard: React.FC<LicenseCardProps> = ({ licenseType }) => {
  const isStandard = licenseType === STANDARD.KEY;
  const isAdvanced = licenseType === ADVANCED.KEY;
  const isDedicated = licenseType === DEDICATED.KEY;

  return (
    <StyledCardContainer>
      <StyledPassiveCard selected={isStandard}>
        <StandardIcon selected={isStandard} />
        <StyledCardTitle>Standard</StyledCardTitle>
        <StyledCardText>
          <StyledCheckIcon selected={isStandard} />
          25 KB/second (roughly 100 events per second)
        </StyledCardText>
        <StyledCardText>
          <StyledCheckIcon selected={isStandard} />
          Run up to five feeds and analytics at a time
        </StyledCardText>
      </StyledPassiveCard>
      <StyledPassiveCard selected={isAdvanced}>
        <AdvancedIcon selected={isAdvanced} />
        <StyledCardTitle>Advanced</StyledCardTitle>
        <StyledCardText>
          <StyledCheckIcon selected={isAdvanced} />
          250 KB/second (roughly 1,000 events per second)
        </StyledCardText>
        <StyledCardText>
          <StyledCheckIcon selected={isAdvanced} />
          Run up to 10 feeds or more at any given time (with optional
          subscription add-ons)
        </StyledCardText>
      </StyledPassiveCard>
      <StyledPassiveCard selected={isDedicated}>
        <DedicatedIcon selected={isDedicated} />
        <StyledCardTitle>Dedicated</StyledCardTitle>
        <StyledCardText>
          <StyledCheckIcon selected={isDedicated} />
          2,500 KB/second and up (roughly 10,000 events per second)
        </StyledCardText>
        <StyledCardText>
          <StyledCheckIcon selected={isDedicated} />
          Run up to 20 feeds and analytics or more at any given time (with
          optional add-ons)
        </StyledCardText>
      </StyledPassiveCard>
    </StyledCardContainer>
  );
};

export default LicenseCard;
